module.exports = __webpack_public_path__ + "img/speaker-page-bg.59a3d46c.png";